import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MmtVisitDetail, MmtCovidVisitDetail, MmtVisitUpdateDetail, MmtFormOptions } from '../models/mmt.model';

@Injectable({
    providedIn: 'root'
})
export class HttpMmtService {

    constructor(private http: HttpClient) { }

    getFormOptions(): Observable<MmtFormOptions> {
        return this.http.get<MmtFormOptions>(environment.baseUrl + 'weedfree/form/mmt/form-options');
    }

    addVisit(visit: MmtVisitDetail): Observable<number> {
        return this.http.post<number>(environment.baseUrl + 'weedfree/form/mmt/add-visit', visit);
    }

    updateVisit(visit: MmtVisitUpdateDetail): Observable<boolean> {
        return this.http.post<boolean>(environment.baseUrl + 'weedfree/form/mmt/update-visit', visit);
    }

    addCovidVisit(visit: MmtCovidVisitDetail): Observable<number> {
        return this.http.post<number>(environment.baseUrl + 'weedfree/form/mmt-covid/add-visit', visit);
    }

    uploadVisitFiles(visit: number, files: any[]) {
        return this.uploadFiles(visit, files, 'weedfree/form/mmt/upload-photos');
    }

    uploadCovidFiles(visit: number, files: any[]) {
        return this.uploadFiles(visit, files, 'weedfree/form/mmt-covid/upload-photos');
    }

    setPoNumber(visit: number, po: string): Observable<boolean> {
        return this.http.post<boolean>(environment.baseUrl + 'weedfree/form/mmt/set-po', { visit: visit, po: po });
    }

    uploadFiles(visit: number, files: any[], url: string) {

        let formData = new FormData();

        formData.append('id', String(visit));

        for (const file of files) {
            formData.append('files[]', file, file.name);
        }

        return this.http.post(
            environment.baseUrl + url,
            formData,
            {
                reportProgress: true,
                observe: 'events'
            }).pipe(map((event) => {

                switch (event.type) {
                    case HttpEventType.UploadProgress:
                        const progress = Math.round(100 * event.loaded / event.total);
                        return { status: 'progress', message: progress };

                    case HttpEventType.Response:
                        return { status: 'complete', message: event.body };

                    default:
                        return { status: 'error', message: 'Unhandled event: ' + event.type };
                }

            }));
    }
}
